import React, {useEffect, useState} from "react";
import Switch from "@mui/material/Switch";
import {AdminGenRouteUrls, AdminKeys, AdminModuleFieldsData, AdminModuleRouteUrls, AdminModules, AdminReqUrls, AppName} from "../config/AdminConfig";
import {Anchor, Flexbox, GridBox, Label, MsgBox} from "../../common/fusion-ui";
import {useTheme} from "../../common/ProjectThemeProvider";
import {clearAdminSessionData, clearRememberLastUrl, getAdminSessionToken, getRememberLastUrl, sendAdminRequest} from "../utils/AdminUtils";
import {
    addClass,
    checkNullJson,
    checkNullStr,
    deleteJsonKeys,
    focusFormIdElement,
    getDefStr,
    getElement,
    getJsonValue,
    getJsonValueFromNestedKeys,
    getUrlMainDomain,
    isBoolTrue,
    isJsonValueTrue,
    setTabTitle
} from "../../common/fusion-ui/utils/ReactUtils";
import {CssVariant} from "../../common/fusion-ui/config/FusionConfig";
import useScreenSize from "../../common/fusion-ui/hook/useScreenSize";
import {printError, printLog} from "../../common/CommonUtils";
import {ThemedButton, ThemedInput,} from "../../common/components";
import {useLocalStoreData} from "../context/LocalStoreProvider";
import {AuthPageLayout} from "../components";
import {useInternetStatus} from "../../common/fusion-ui/hook";
import {clearUserSessionData} from "../../app/utils/AppUtils";
import {IsProd} from "../../common/CommonConfig";

const LoginPage = React.memo(() => {
    const TAG = 'LoginPage';

    const theme = useTheme();
    const {updateLocalStoreField} = useLocalStoreData();
    const {isScreenUpSm} = useScreenSize();
    const {isOnline} = useInternetStatus();

    const FOCUS_DELAY = 2000;
    const INPUT_H = '46px';

    const Fields = {
        username: 'username',
        password: 'password',
        rememberMe: 'rememberMe',

        usernameMsg: 'usernameMsg',
        passwordMsg: 'passwordMsg',

        submitAsLoading: 'submitAsLoading',
        submitDisable: 'submitDisable',
        panelMsg: 'panelMsg',
        panelMsgColor: 'panelMsgColor',
    };
    const [fieldsData, setFieldsData] = useState({});

    useEffect(() => {
        setTabTitle(AdminModules.Login);
    }, []);

    return (<AuthPageLayout className={'py-sm-4'} px={0} py={1}
                            containerClassName={'container-sm'}
                            asContainer={false} asContainerFluid={false}>
        <GridBox className={'m-0 p-0 auth-page'}
                 sm={12} md={7}
                 alignAt={'center'} justifyAt={'center'}
                 minHeight={isScreenUpSm ? '84vh' : '85vh'}>
            <div className={'m-0 p-0x row jc-center'}>
                {/*<div>*/}
                {/*    <label>isOnline: {isOnline}</label>*/}
                {/*</div>*/}
                <div className={`col-sm-8 col-md-10 col-lg-8 auth-panel-wrapper admin`}>
                    {/*top*/}
                    <div className={'m-0 p-0'}>
                        {/*<Flexbox justifyAt={'center'}>*/}
                        {/*    <Image*/}
                        {/*        wrapperClassName={''}*/}
                        {/*        className={''}*/}
                        {/*        src={KnPLogo}*/}
                        {/*        width={'auto'}*/}
                        {/*        height={'54px'}*/}
                        {/*    />*/}
                        {/*</Flexbox>*/}

                        <Flexbox className={'mt-3x'} justifyAt={'center'}>
                            <Label className={'fw-bold fs-xl text-nowrap text-theme'}>
                                {AppName}
                            </Label>
                        </Flexbox>

                        <Flexbox className={'mt-2 pt-1x'} justifyAt={'center'}>
                            <Label className={'fw-bold fs-lg text-theme-resp'}>
                                Login
                            </Label>
                        </Flexbox>
                        {!isScreenUpSm && <Flexbox className={'mt-2x'} justifyAt={'center'}>
                            <Label className={'text-theme-resp-90'} textAt={'start'}>
                                Please enter your credentials to login
                            </Label>
                        </Flexbox>}
                    </div>

                    {/*form*/}
                    <div className={'m-0 p-0 mt-3'}>
                        <form onSubmit={handleSubmit}>
                            {/*username*/}
                            <ThemedInput
                                mainWrapperClassName={`w-100 pb-2`}
                                className={`py-3`}
                                style={{height: INPUT_H}}
                                type={'email'}
                                id={Fields.username}
                                label={'Username'}
                                placeholder={'Enter your username'}
                                value={getField(Fields.username)}
                                required={true}
                                msg={getField(Fields.usernameMsg)}
                                onChange={(e, isValid) => {
                                    const value = e.target.value;
                                    updateField(Fields.username, value);
                                    if (checkNullStr(value)) {
                                        highlightIdField(Fields.username, false, Fields.usernameMsg, '');
                                    }
                                    panelLog('');
                                }}
                            />

                            {/*password*/}
                            <ThemedInput
                                mainWrapperClassName={`w-100 pb-2`}
                                className={`py-3`}
                                style={{height: INPUT_H}}
                                type={'password'}
                                id={Fields.password}
                                label={'Password'}
                                placeholder={'Enter your password'}
                                value={getField(Fields.password)}
                                required={true}
                                msg={getField(Fields.passwordMsg)}
                                onChange={(e, isValid) => {
                                    const value = e.target.value;
                                    updateField(Fields.password, value);
                                    if (checkNullStr(value)) {
                                        highlightIdField(Fields.password, false, Fields.passwordMsg, '');
                                    }
                                    panelLog('');
                                }}
                            />

                            {/*remember-switch*/}
                            <Flexbox className={'mt-n2'} alignAt={'center'} justifyAt={'start'}>
                                <Switch checked={isFieldTrue(Fields.rememberMe)} onChange={handleSetRememberMe}/>

                                <Label className={'m-0 p-0  text-nowrap select-none'} textAt={'start'} color={theme.text80}>
                                    &nbsp;&nbsp;{' Remember me'}
                                </Label>
                            </Flexbox>

                            {/*msg-box*/}
                            {(checkNullStr(getField(Fields.panelMsg)) || !isOnline) &&
                                <MsgBox color={!isOnline ? 'red' : getField(Fields.panelMsgColor, theme.text90)}>
                                    {!isOnline ? `You're offline!` : getField(Fields.panelMsg)}
                                </MsgBox>}


                            {/*submit*/}
                            <div className={'m-0 p-0 mt-2 mb-1 w-100'}>
                                <ThemedButton
                                    className={'w-100 px-2 py-2 rounded-3 fw-semi-bold'}
                                    text={isFieldTrue(Fields.submitAsLoading) ? 'Signing in...' : AdminModules.Login}
                                    height={INPUT_H}
                                    elasticActive={true}
                                    loadingWidth={'100%'}
                                    asLoading={isFieldTrue(Fields.submitAsLoading)}
                                    disabled={isFieldTrue(Fields.submitDisable) || !isOnline}
                                    onClick={handleSubmit}
                                />

                                {!IsProd && <ThemedButton
                                    className={'w-100 px-2 py-2 mt-4 rounded-3'}
                                    text={`VoK Login`}
                                    variant={theme.primaryAlt}
                                    variantLight={theme.primaryAltLight}
                                    href={'/login'}
                                    asLink={false}
                                />}
                            </div>

                            {/*forgot-pw*/}
                            <Flexbox className={'w-100 mt-3 px-0'} justifyAt={'end'}>
                                {/*forgot-pw*/}
                                <Anchor
                                    wrapperClassName={'td-none'}
                                    className={'text-nowrap fw-semi-boldx td-none'}
                                    href={AdminGenRouteUrls.forgotPw}>
                                    {AdminModules.ForgotPw}?
                                </Anchor>
                            </Flexbox>
                        </form>
                    </div>
                </div>
            </div>
        </GridBox>
    </AuthPageLayout>);

    function handleSubmit() {
        const fun = 'handleSubmit:';
        panelLog('');
        clearAdminSessionData();
        try {
            let verified = checkAllFieldsVerified();
            // verified = false;
            if (verified) {
                updateField(Fields.submitAsLoading, true);
                updateField(Fields.submitDisable, true);
                const mf = AdminModuleFieldsData[AdminModules.MyAccount];

                const REQUEST_OPTIONS = {
                    username: getField(Fields.username),
                    password: getField(Fields.password),
                    token: getAdminSessionToken(),
                    browserUrl: window.location.href,
                };

                sendAdminRequest({
                    reqUrl: AdminReqUrls.admin__login,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: (fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);

                        const message = getJsonValue(fetchedData, 'message');
                        const success = isJsonValueTrue(fetchedData, 'success');

                        if (success) {
                            const userData = getJsonValueFromNestedKeys(fetchedData, ['data', AdminKeys.sessionData], {});
                            const token = getJsonValueFromNestedKeys(fetchedData, ['data', AdminKeys.sessionToken], '');

                            //Delete p/w fields
                            deleteJsonKeys(userData, [mf.password.column, mf.passwordV2.column]);

                            // log(fun, 'fetchedData.token:', token);
                            log(fun, 'fetchedData.userData:', userData);
                            if (checkNullStr(token) && checkNullJson(userData)) {
                                panelLog(message);
                                updateLocalStoreField(AdminKeys.sessionData, {...userData, [AdminKeys.sessionToken]: token}, true);

                                //Redirect-url
                                const intendedUrl = getDefStr(getRememberLastUrl(), `${getUrlMainDomain(window.location.href)}${AdminModuleRouteUrls[AdminModules.Dashboard]}`);
                                log(fun, 'intendedUrl:', intendedUrl);
                                clearRememberLastUrl();

                                //Clear vok-user session
                                clearUserSessionData();

                                window.location.href = intendedUrl;
                            } else {
                                panelLogErr('Login failed, please try again');
                                clearAdminSessionData();

                                if (!checkNullStr(token)) logErr('Token empty (from backend)');
                                if (!checkNullStr(userData)) logErr('User-data empty (from backend)');

                                log(fun, 'fetchedData.userData:', userData, 'token:', token);
                            }
                        } else {
                            panelLogErr(message);
                            clearAdminSessionData();
                        }
                        updateField(Fields.submitAsLoading, false);
                        updateField(Fields.submitDisable, false);
                    },
                    onError: (error) => {
                        performFailureTasks(error);
                    }
                });
            }
        } catch (error) {
            performFailureTasks(error);
        }

        function performFailureTasks(error) {
            panelLogErr('Login failed, please try again');
            updateField(Fields.submitAsLoading, false);
            updateField(Fields.submitDisable, false);
            if (error) logErr(fun, error);
            clearAdminSessionData();
        }
    }

    function checkAllFieldsVerified() {
        let verified = false;
        if (!checkNullStr(getField(Fields.username))) {
            updateField(Fields.usernameMsg, 'Username cannot be empty');
            focusIdField(Fields.username);
        } else if (!checkNullStr(getField(Fields.password))) {
            focusIdField(Fields.password);
            updateField(Fields.passwordMsg, 'Password cannot be empty');
        } else {
            updateField(Fields.usernameMsg, '');
            updateField(Fields.passwordMsg, '');
            verified = true;
            panelLog("");
        }
        return verified;
    }

    function handleSetRememberMe() {
        updateField(Fields.rememberMe, !isFieldTrue(Fields.rememberMe));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function focusIdField(id, onlyFocus = true) {
        focusFormIdElement(id, onlyFocus, FOCUS_DELAY);
        highlightIdField(id, true);
    }

    function highlightIdField(id, highlight = true, msgField, msg, variant = CssVariant.danger) {
        if (checkNullStr(msgField)) updateField(msgField, msg);
        addClass(getElement(id, 'id'), variant, isBoolTrue(highlight));
    }

    function panelLog(text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, theme.text90);
        if (text) log(...[text]);
        ;
    }

    function panelLogErr(...text) {
        updateField(Fields.panelMsg, text);
        updateField(Fields.panelMsgColor, 'red');
        if (text) log(...[text]);
        ;
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }
});

export default LoginPage;
